import { useMemo } from 'react';
import { SortedTableRow } from '@/features/ai-agents/chat/MarkdownTableVisualization/types';
import {
  createChartData,
  createVariantChartSeries,
} from '@/features/ai-agents/chat/MarkdownTableVisualization/utils';

interface UseChartDataOptions {
  isVariantReport: boolean;
  selectedXColumnIndex: number;
  selectedYColumnIndex: number;
  sortedRows: SortedTableRow[];
  variantColumnIndex: number;
}

export function useChartData({
  isVariantReport,
  selectedXColumnIndex,
  selectedYColumnIndex,
  sortedRows,
  variantColumnIndex,
}: UseChartDataOptions) {
  const chartData = useMemo(
    () =>
      createChartData(
        sortedRows.map((row) => row.values),
        selectedXColumnIndex,
        selectedYColumnIndex,
      ),
    [sortedRows, selectedXColumnIndex, selectedYColumnIndex],
  );
  const variantSeries = useMemo(
    () =>
      isVariantReport
        ? createVariantChartSeries(
            sortedRows.map((row) => row.values),
            variantColumnIndex,
            selectedXColumnIndex,
            selectedYColumnIndex,
          )
        : [],
    [
      isVariantReport,
      sortedRows,
      variantColumnIndex,
      selectedXColumnIndex,
      selectedYColumnIndex,
    ],
  );

  return { chartData, variantSeries };
}
